export default __webpack_public_path__ + "static/media/jnc.a0a6dfa4.png";